import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './SPSCommerce.frontend.types'

@Injectable({ providedIn: 'root' })
export class SPSCommerce_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public SPSCommerce: SPSCommerce_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
